module.exports = __webpack_public_path__ + "img/1-6.0e298dc1.png";